import React from 'react'

const ChatLoadingState: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-app-white-100">
      <div className="flex flex-col items-center gap-3">
        <div className="h-12 w-12 animate-spin rounded-full border-4 border-app-grey-30 border-t-app-primary-60"></div>
        <div className="text-md text-app-grey-60">Loading conversations...</div>
      </div>
    </div>
  )
}

export default ChatLoadingState
